import { Adapter } from "@/core/models/adapter";

export const WAREHOUSE_CHECKIN_OPTIONAL = "optional";
export const WAREHOUSE_CHECKIN_MANDATORY = "mandatory";
export const WAREHOUSE_CHECKIN_DISABLED = "disabled";

export class OrganizationRootDetails {
  constructor() {
    this.id = null;
    this.sellerSupportEmail = null;
    this.eula = null;
    this.serviceTerms = null;
    this.faqAndContact = null;
    this.isWarehouseCommentMandatory = false;
    this.isWarehouseCommentSharedToClient = false;
    this.buybackZeroDescription = null;
    this.noSearchResultDescription = null;
    this.enabledPremiumFeatures = [];
    this.categoryNavigationEnabled = false;
    this.customerIdentityDocumentRequired = true;
    this.warehouseCheckinRequirement = null;
    this.barCodeEnabled = false;
    this.tagPriceEnabled = false;
    this.buyerPaymentEnabled = false;
    this.cartMinValue = 0;
  }
}

export class OrganizationRootDetailsAdapter extends Adapter {
  /**
   * @param {OrdApi} organizationRootDetailsApi
   * @return {OrganizationRootDetails}
   */
  static adapt(organizationRootDetailsApi) {
    const organizationRootDetails = new OrganizationRootDetails();
    organizationRootDetails.id = organizationRootDetailsApi?.id;
    organizationRootDetails.sellerSupportEmail = organizationRootDetailsApi?.sellerSupportEmail;
    organizationRootDetails.eula = organizationRootDetailsApi?.eula;
    organizationRootDetails.serviceTerms = organizationRootDetailsApi?.serviceTerms;
    organizationRootDetails.faqAndContact = organizationRootDetailsApi?.faqAndContact;
    organizationRootDetails.isWarehouseCommentMandatory = organizationRootDetailsApi?.isWarehouseCommentMandatory;
    organizationRootDetails.isWarehouseCommentSharedToClient =
      organizationRootDetailsApi?.isWarehouseCommentSharedToClient;
    organizationRootDetails.buybackZeroDescription = organizationRootDetailsApi?.buybackZeroDescription;
    organizationRootDetails.noSearchResultDescription = organizationRootDetailsApi?.noSearchResultDescription;
    organizationRootDetails.enabledPremiumFeatures = organizationRootDetailsApi?.enabledPremiumFeatures ?? [];
    organizationRootDetails.categoryNavigationEnabled = organizationRootDetailsApi?.categoryNavigationEnabled ?? false;
    organizationRootDetails.customerIdentityDocumentRequired =
      organizationRootDetailsApi?.customerIdentityDocumentRequired ?? false;
    organizationRootDetails.warehouseCheckinRequirement =
      organizationRootDetailsApi?.warehouseCheckinRequirement ?? null;
    organizationRootDetails.barCodeEnabled = organizationRootDetailsApi?.barCodeEnabled ?? false;
    organizationRootDetails.buyerPaymentEnabled = organizationRootDetailsApi?.buyerPaymentEnabled ?? false;
    organizationRootDetails.tagPriceEnabled = organizationRootDetailsApi?.tagPriceEnabled ?? false;
    organizationRootDetails.cartMinValue = organizationRootDetailsApi?.cartMinValue ?? 0;

    return organizationRootDetails;
  }
}
